/** Mega Trivia Random: upsell de short real y add.js nativo, sin descuentos ficticios */
(() => {
 'use strict';
 const rootPath = () => window.Shopify?.routes?.root || '/';
 const money = (n, c) => new Intl.NumberFormat('es-UY',{style:'currency',currency:c||'UYU',maximumFractionDigits:2,minimumFractionDigits:0}).format(Number(n)/100);
 function init(root) {
  if(root.dataset.rstReady) return;
  root.dataset.rstReady='1';
  const $ = s=>root.querySelector(s), $$=s=>Array.from(root.querySelectorAll(s));
  const form=$('[data-rst-form]'), submit=$('[data-rst-submit]');
  if(!form) return;
  const main=JSON.parse($('[data-rst-main]').textContent);
  const radios=$$('input[type="radio"][name^="rst-extra-"]');
  const rows=$$('[data-rst-for]');
  const feedback=$('[data-rst-error]'), total=$('[data-rst-total]');
  const amount=Number(root.dataset.threshold)||200000;
  const success=$('[data-rst-success]');
  let currentCart=0,busy=false;
  function selected() {
   const radio=radios.find(r=>r.checked);
   const row=radio && radio.value ? rows.find(r=>r.dataset.rstFor===radio.value):null;
   const variant=row?.querySelector('select');
   const option=variant?.selectedOptions[0];
   return {row,option};
  }
  function totalCents(){const s=selected();return Number(main.price)+Number(s.option?.dataset.price||0);}
  function refresh() {
   const s=selected();
   rows.forEach(row=>{row.hidden=row!==s.row;row.querySelector('select').disabled=row!==s.row;});
   radios.forEach(r=>r.closest('label').classList.toggle('is-active',r.checked));
   total.textContent=money(totalCents(),root.dataset.currency);
   const isValid=main.available===true && (!s.row || Boolean(s.option && !s.option.disabled));
   submit.disabled=busy||!isValid;
   const text=$('[data-rst-submit-label]');
   if(!busy)text.textContent=!main.available?'TRIVIA SIN STOCK':isValid?'AGREGAR MI TRIVIA':'REVISÁ EL TALLE';
   const pending=Math.max(0,amount-currentCart-totalCents());
   $('[data-rst-dac-fill]').style.width=`${Math.min(100,(currentCart+totalCents())/amount*100)}%`;
   $('[data-rst-dac-title]').textContent=pending===0?'CON ESTA SELECCIÓN ALCANZÁS EL UMBRAL DAC':`TE FALTARÍAN ${money(pending,root.dataset.currency)} PARA CUBRIR DAC`;
   $('[data-rst-dac-caption]').textContent='Estimado, sujeto al total final';
  }
  radios.forEach(r=>r.addEventListener('change',()=>{feedback.textContent='';refresh();}));
  rows.forEach(row=>row.querySelector('select').addEventListener('change',()=>{feedback.textContent='';refresh();}));
  form.addEventListener('submit',async event=>{
   event.preventDefault();
   if(busy||!main.available) return;
   const s=selected();
   if(s.row && (!s.option||s.option.disabled)) {feedback.textContent='Elegí un talle disponible';return;}
   const items=[{id:Number(main.id),quantity:1}];
   if(s.option)items.push({id:Number(s.option.value),quantity:1});
   busy=true;refresh();$('[data-rst-submit-label]').textContent='AGREGANDO…';feedback.textContent='';
   try{
    const response=await fetch(rootPath()+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    const data=await response.json().catch(()=>({}));
    if(!response.ok)throw Error(data.description||data.message||'No se pudo agregar el pedido');
    success.hidden=false;
    feedback.textContent='Tu pedido se agregó al carrito';feedback.classList.add('is-success');
    try{
      const cart=await fetch(rootPath()+'cart.js',{credentials:'same-origin'}).then(r=>r.json());
      currentCart=Number(cart.total_price)||0;
      const bubble=document.querySelector('#cart-icon-bubble .cart-count-bubble');
      const count=bubble?.querySelector('[aria-hidden="true"]');
      if(count)count.textContent=String(cart.item_count);
    }catch(_){/* compra exitosa; carrito refresca al navegar */}
   }catch(error){feedback.textContent=error.message||'Error al agregar';feedback.classList.remove('is-success');success.hidden=true;}
   finally{busy=false;refresh();}
  });
  $('[data-rst-dismiss]')?.addEventListener('click',()=>{success.hidden=true;});
  const slides=$$('[data-rst-slide]'), thumbs=$$('[data-rst-thumb]');
  let index=0;
  function show(n){if(!slides.length)return;index=(n+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==index;if(i!==index){slide.querySelectorAll('video').forEach(v=>{if(!v.paused)v.pause();});slide.querySelectorAll('iframe').forEach(f=>{const src=f.getAttribute('src');if(src&&f.dataset.rspActivated==='true'){f.setAttribute('src',src);f.dataset.rspActivated='false';}});}else{slide.querySelectorAll('iframe').forEach(f=>{f.dataset.rspActivated='true';});}});thumbs.forEach((b,i)=>{b.classList.toggle('is-active',i===index);b.setAttribute('aria-pressed',String(i===index));});if($('[data-rst-count]'))$('[data-rst-count]').textContent=`${String(index+1).padStart(2,'0')} / ${slides.length}`;}
  slides[0]?.querySelectorAll('iframe').forEach(f=>{f.dataset.rspActivated='true';});
  thumbs.forEach(b=>b.addEventListener('click',()=>show(Number(b.dataset.rstThumb))));
  $('[data-rst-prev]')?.addEventListener('click',()=>show(index-1));
  $('[data-rst-next]')?.addEventListener('click',()=>show(index+1));
  refresh();
  fetch(rootPath()+'cart.js',{credentials:'same-origin'}).then(r=>r.json()).then(cart=>{currentCart=Number(cart.total_price)||0;refresh();}).catch(()=>{});
 }
 function all(context=document){if(context.matches?.('[data-rst-root]'))init(context);context.querySelectorAll('[data-rst-root]').forEach(init);}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>all());else all();
 document.addEventListener('shopify:section:load',event=>all(event.target));
})();
